/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationDetailBatchRequest extends models.PromptRecommendationDetailRequestBase {
    getFixupPrototypeFunction() { return PromptRecommendationDetailBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationDetailBatchRequest>): PromptRecommendationDetailBatchRequest {
        let obj = Object.assign(new PromptRecommendationDetailBatchRequest(), model);
        PromptRecommendationDetailBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationDetailBatchRequest>): PromptRecommendationDetailBatchRequest {
        if (!model) return null;
        return PromptRecommendationDetailBatchRequest.newInstance(<PromptRecommendationDetailBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationDetailBatchRequest) {
        if (!obj) return;

        models.PromptRecommendationDetailBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationDetailBatchRequest): boolean {
        if (models.PromptRecommendationDetailRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PromptRecommendationDetailBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.recommendation_ids) {
            models.BatchRequest.fixupPrototype(this.recommendation_ids);
        }
    }

    /**
     * ids for the recommendation
     */
    recommendation_ids: models.BatchRequest;

}
